import { observable, action } from 'mobx'

interface ITempFilter {
  searchQuery: string
  selectedSupplierId: number | undefined
  selectedCategoryId: string | undefined
  offset: number
  limit: number
  selectedCategoryIds: string[]
  selectedLocationIds: number[]
  productIds: string[]
}

export class QueryFilter {
  @observable
  history: any

  @observable
  inventoryFilter: ITempFilter = {
    searchQuery: '',
    selectedSupplierId: undefined,
    selectedCategoryId: undefined,
    offset: 0,
    limit: 20,
    selectedCategoryIds: [],
    selectedLocationIds: [],
    productIds: [],
  }

  constructor(history: any) {
    this.history = history

    const {
      searchQuery,
      offset,
      limit,
      selectedSupplierId,
      selectedCategoryId,
      selectedCategoryIds,
      selectedLocationIds,
      productIds,
    } = history.getCurrentLocation().query

    // If url params exist, fill them in
    if (searchQuery) {
      this.inventoryFilter.searchQuery = searchQuery
    }
    if (offset) {
      this.inventoryFilter.offset = parseInt(offset)
    }
    if (limit) {
      this.inventoryFilter.limit = parseInt(limit)
    }
    if (selectedSupplierId) {
      this.inventoryFilter.selectedSupplierId = parseInt(selectedSupplierId)
    }
    if (selectedCategoryId) {
      this.inventoryFilter.selectedCategoryId = selectedCategoryId
    }

    if (selectedCategoryIds) {
      const newNumberCategoryIdArray = Array.isArray(selectedCategoryIds)
        ? selectedCategoryIds
        : [selectedCategoryIds]

      this.setSelectedCategoryIds(newNumberCategoryIdArray)
    }

    if (selectedLocationIds) {
      const newNumberLocationIdArray = Array.isArray(selectedLocationIds)
        ? selectedLocationIds.map((id: string) => parseInt(id))
        : [parseInt(selectedLocationIds)]

      this.setSelectedLocationIds(newNumberLocationIdArray)
    }

    if (productIds) {
      this.inventoryFilter.productIds = productIds
    }

    this.apply()
  }

  apply() {
    this.history.replace({
      pathname: this.history.getCurrentLocation().pathname,
      query: this.inventoryFilter,
    })
  }

  @action
  setLimit(limit: number) {
    this.inventoryFilter.limit = limit
  }

  @action
  setOffset(offset: number) {
    this.inventoryFilter.offset = offset
  }

  @action
  setSelectedLocationIds(selectedLocationIds: number[]) {
    this.inventoryFilter.selectedLocationIds = selectedLocationIds
  }

  @action
  setSelectedCategoryIds(selectedCategoryIds: string[]) {
    this.inventoryFilter.selectedCategoryIds = selectedCategoryIds
  }

  @action
  toggleSelectedCategoryIds(selectedCategoryId: string) {
    const { selectedCategoryIds } = this.inventoryFilter

    let newSelectedCategoryIds: string[] = []
    if (selectedCategoryIds.includes(selectedCategoryId)) {
      newSelectedCategoryIds = selectedCategoryIds.filter((id) => id !== selectedCategoryId)
    } else {
      newSelectedCategoryIds = [...selectedCategoryIds, selectedCategoryId]
    }
    this.setSelectedCategoryIds(newSelectedCategoryIds)
  }

  @action
  toggleSelectedLocationIds(selectedLocationId: number) {
    const { selectedLocationIds } = this.inventoryFilter

    let newSelectedLocationIds: number[] = []
    if (selectedLocationIds.includes(selectedLocationId)) {
      newSelectedLocationIds = selectedLocationIds.filter((id) => id !== selectedLocationId)
    } else {
      newSelectedLocationIds = [...selectedLocationIds, selectedLocationId]
    }

    this.setSelectedLocationIds(newSelectedLocationIds)
  }

  @action
  setSearchQuery = (searchQuery: string) => {
    this.inventoryFilter.searchQuery = searchQuery
  }

  @action
  setProductIds(productIds: string[]) {
    this.inventoryFilter.productIds = productIds
  }
}
